<div class="min-h-screen flex items-center justify-center bg-gray-50 px-4">
  <div class="w-full max-w-md bg-white rounded-lg shadow p-8">
    <h1 class="text-2xl font-semibold mb-1">Reset password</h1>

    @if (!isSent) {
      <p class="text-sm text-gray-600 mb-6">Enter your email and we'll send a reset link.</p>
      <form [formGroup]="form" (ngSubmit)="onSubmit()" class="space-y-4">
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1" for="email">Email</label>
          <input id="email" type="email" formControlName="email"
            class="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            autocomplete="email" />
        </div>
        <button type="submit" [disabled]="form.invalid || isSubmitting"
          class="w-full bg-blue-600 text-white font-medium py-2 rounded-md hover:bg-blue-700 disabled:opacity-50">
          {{ isSubmitting ? 'Sending…' : 'Send reset link' }}
        </button>
      </form>
    } @else {
      <p class="text-sm text-gray-700 mb-6">
        If an account exists for <span class="font-medium">{{ submittedEmail }}</span>,
        we've sent a password reset link. Check your inbox.
      </p>
      <p class="text-sm text-gray-500">
        The link expires in 72 hours.
      </p>
    }

    <p class="mt-6 text-sm text-gray-600">
      <a routerLink="/login" class="text-blue-600 hover:underline">Back to sign in</a>
    </p>
  </div>
</div>
